<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.categ.uniq_id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">

				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{this.categ.title}}
								<small class="text-muted mb-0">
									{{__t('categ_info')}}
								</small>
							</h5>
						</div>

						<div>
							<b-tabs content-class="mt-3">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>

									<component v-bind:is="tab.index" :categ="categ"></component>
									<div v-if="tab.html !=''">
										{{tab.html}}
									</div>
								</b-tab>
							</b-tabs>
						</div>
						<div>
					</div>
				</div>
				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" @click="remove" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="categ.id > 0">
					{{ __t('REMOVE') }}
				</button>

				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					{{ __t('CLOSE') }}
				</button>

				<button type="button" v-on:click="save_categ" class="btn btn-primary waves-effect waves-themed">
					{{ __t('SAVE') }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import Info_field from "../../../sys/info_field";
import categ_info from "./tabs/categ_info";
import categ_settings from "./tabs/categ_settings";
import categ_products from "./tabs/categ_products";
import categ_tree from "./tabs/categ_tree";
import categ_image from "./tabs/categ_image";
import categ_translate from "./tabs/categ_translate";
import categ_mode from "./tabs/categ_mode";

export default {
	name: "categ_modal",
	components : {
		Info_field,
		categ_info,
		categ_settings,
		categ_products,
		categ_tree,
		categ_image,
        categ_translate,
        categ_mode,
	},
	props : {
		modal_position : {
			type : String,
			default : "right"
		},


	},
	data() {
		return  {
			is_show_modal : false,
			is_load_adv : false,
			is_load : false,
			categ: {
				id : 0,
				title : "",
				uniq_id : "",
				is_main : false,
				categ_products : [],
                visible_providers : [],

			},
			tabs:[]
		}
	},
	created() {
		EventBus.$on("categ_edit", this.work_click);
		EventBus.$on("close_categ",this.close);
	},

	methods : {
		async remove() {
			let self = this;
			const is_ok = confirm_me(this.__t("ARE_SURE"));
			is_ok.then(res => {
				self.is_load = true;
				api.delete('/internal/v1/catalog/categories/' + this.categ.id).then(({data}) => {
					self.is_load = false;
					if (data.status === "operation_success") {
                        self.close();
                        EventBus.$emit("reload_categories");
					}
				}).catch(({response}) => {
					self.is_load = false;
					EventBus.$emit('show_toast', {
						err: response.data.message,
                        type: "danger",
						title: response.data.status,
						position : "b-toaster-top-left"
					})
				});
			});
		},

		save_categ() {
			EventBus.$emit("save_categ_called");
		},

		close() {
			this.categ = {
				id : 0,
				title : "",
				uniq_id : "",
				glovo_restaurants : [],
			};

			this.tabs = [];
			this.is_show_modal = false;

		},

		work_click(categ_id) {
			this.categ.id = parseInt(categ_id);
			this.is_show_modal = true;
			this.load_categ_advanced();
		},

		async load_categ_advanced() {
			this.tabs = [];
            this.is_load = true;

			await api.get('/internal/v1/catalog/categories/' + this.categ.id).then(({data}) => {
				if (data.status === "operation_success") {
                    this.categ =  data.data;
                    this.is_load = false;
                    this.push_tabs();
				}
			}).catch(({response}) => {
                this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
			});
		},

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},


		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}

			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},
	},


	computed : {

        default_tabs() {

            return [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "categ_info",
                    is_active:true,
                },
                {
                    "title": this.__t('ADVANCED_SETTINGS'),
                    "index": "categ_settings",
                    is_active:false,
                },

                {
                    "title": this.__t('CATEGORY_MODE'),
                    "index": "categ_mode",
                    is_active:false,
                },
                {
                    "title": this.__t('CATEG.TREE'),
                    "index": "categ_tree",
                    is_active:false,
                },
                {
                    "title": this.__t('PHOTO'),
                    "index": "categ_image",
                    is_active:false,
                },
                {
                    "title": this.__t('LANGUAGES'),
                    "index": "categ_translate",
                    is_active:false,
                }
            ];
        },

		providers_services() {
			return this.categ.visible_providers;
		},

		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},
	}

}
</script>

<style scoped>

</style>
